// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
// Try different import syntaxes if the default doesn't work
import MainAppRoutes from './MainAppRoutes';
// Or alternatively:
// import { default as MainAppRoutes } from './MainAppRoutes';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <MainAppRoutes />
  </React.StrictMode>
);